import { render, staticRenderFns } from "./UploadCoreCustomersCSV.vue?vue&type=template&id=3ef1c0bd"
import script from "./UploadCoreCustomersCSV.vue?vue&type=script&lang=js"
export * from "./UploadCoreCustomersCSV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports